var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirewalls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "firewalls_svg__a",
    x1: 9,
    y1: 14.14,
    x2: 9,
    y2: 1.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.14a4.06 4.06 0 00-3.51-3.89 5.1 5.1 0 00-5.25-4.87 5.23 5.23 0 00-5 3.41A4.82 4.82 0 000 9.43a4.9 4.9 0 005.07 4.71h8.65a1.46 1.46 0 00.22 0 4.1 4.1 0 004.06-4z",
    fill: "url(#firewalls_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.29 11.19a.42.42 0 00-.42-.41H4.13a.42.42 0 00-.42.41v5a.42.42 0 00.42.41h9.74a.42.42 0 00.42-.41v-5z",
    fill: "#821010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e62323",
    d: "M4.3 11.36h2.87v1.27H4.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7381",
    d: "M7.6 11.36h2.87v1.27H7.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e62323",
    d: "M10.9 11.36h2.87v1.27H10.9zm-6.6 1.7h1.19v1.27H4.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7381",
    d: "M12.58 13.06h1.19v1.27h-1.19zm-6.66 0h2.87v1.27H5.92z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e62323",
    d: "M9.23 13.06h2.87v1.27H9.23zm-4.93 1.7h2.87v1.27H4.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7381",
    d: "M7.6 14.76h2.87v1.27H7.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e62323",
    d: "M10.9 14.76h2.87v1.27H10.9z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iOSIgeTE9IjE0LjE0IiB4Mj0iOSIgeTI9IjEuMzgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMDc4ZDQiLz48c3RvcCBvZmZzZXQ9Ii44MiIgc3RvcC1jb2xvcj0iIzVlYTBlZiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxwYXRoIGQ9Ik0xOCAxMC4xNGE0LjA2IDQuMDYgMCAwMC0zLjUxLTMuODkgNS4xIDUuMSAwIDAwLTUuMjUtNC44NyA1LjIzIDUuMjMgMCAwMC01IDMuNDFBNC44MiA0LjgyIDAgMDAwIDkuNDNhNC45IDQuOSAwIDAwNS4wNyA0LjcxaDguNjVhMS40NiAxLjQ2IDAgMDAuMjIgMCA0LjEgNC4xIDAgMDA0LjA2LTR6IiBmaWxsPSJ1cmwoI2EpIi8+PHBhdGggZD0iTTE0LjI5IDExLjE5YS40Mi40MiAwIDAwLS40Mi0uNDFINC4xM2EuNDIuNDIgMCAwMC0uNDIuNDF2NWEuNDIuNDIgMCAwMC40Mi40MWg5Ljc0YS40Mi40MiAwIDAwLjQyLS40MXYtNXoiIGZpbGw9IiM4MjEwMTAiLz48cGF0aCBmaWxsPSIjZTYyMzIzIiBkPSJNNC4zIDExLjM2aDIuODd2MS4yN0g0LjN6Ii8+PHBhdGggZmlsbD0iI2ZmNzM4MSIgZD0iTTcuNiAxMS4zNmgyLjg3djEuMjdINy42eiIvPjxwYXRoIGZpbGw9IiNlNjIzMjMiIGQ9Ik0xMC45IDExLjM2aDIuODd2MS4yN0gxMC45ek00LjMgMTMuMDZoMS4xOXYxLjI3SDQuM3oiLz48cGF0aCBmaWxsPSIjZmY3MzgxIiBkPSJNMTIuNTggMTMuMDZoMS4xOXYxLjI3aC0xLjE5ek01LjkyIDEzLjA2aDIuODd2MS4yN0g1LjkyeiIvPjxwYXRoIGZpbGw9IiNlNjIzMjMiIGQ9Ik05LjIzIDEzLjA2aDIuODd2MS4yN0g5LjIzek00LjMgMTQuNzZoMi44N3YxLjI3SDQuM3oiLz48cGF0aCBmaWxsPSIjZmY3MzgxIiBkPSJNNy42IDE0Ljc2aDIuODd2MS4yN0g3LjZ6Ii8+PHBhdGggZmlsbD0iI2U2MjMyMyIgZD0iTTEwLjkgMTQuNzZoMi44N3YxLjI3SDEwLjl6Ii8+PC9zdmc+";
export { SvgFirewalls as ReactComponent };